<script>
    import Header from "./Header.svelte";
    import Footer from "./Footer.svelte";
    import ConnectionIssuesModal from "../modal/ConnectionIssuesModal.svelte";
    import Heartbeat from "./Heartbeat.svelte";
    /**
     * @typedef {Object} Props
     * @property {import('svelte').Snippet} [children]
     */

    /** @type {Props} */
    let { children } = $props();

    export {
    }
</script>

<svelte:options />

<Header />
<main id="brak-content">
    {@render children?.()}
</main>
<Footer />

<Heartbeat />
<ConnectionIssuesModal/>

